import { useMutation } from "@apollo/client";

import { GqlSettingsObservationTypeCreateInput } from "~/__generated__";

import { SettingsObservationTypeCreateRoute_CreateDocument } from "../mutations.generated";

export default function useSettingsObservationTypeCreateRoute_Create() {
    const [mutate, { loading, error }] = useMutation(SettingsObservationTypeCreateRoute_CreateDocument, {});

    const createObservationType = async (input: GqlSettingsObservationTypeCreateInput) => {
        const result = await mutate({
            variables: {
                input,
            },
        });

        return result.data?.settingsObservationTypeCreate;
    };

    return {
        createObservationType,
        loading,
        error,
    };
}
